import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const VehicleTypeToggle = ({
    className = undefined,
    disabled = false,
    id = "label-option",
    label = "option",
    onChange = undefined,
    value,
}: any & {
    className?: string;
    disabled: boolean,
    id: string;
    label: string;
    onChange?: (event: object, value: any) => void;
    value?: string;
}) => {
    return (
        <>
            <ToggleButtonGroup
                exclusive
                value={value}
                onChange={onChange}
                aria-label="device"
                size="small"
            >
                <ToggleButton value="Car" aria-label="Car">
                    <Tooltip title="Car" placement="left">
                        <DirectionsCarIcon />
                    </Tooltip>
                </ToggleButton>
                <ToggleButton value="Lcv" aria-label="Lcv">
                    <Tooltip title="Light Commercial Vehicle" placement="right">
                        <LocalShippingIcon />
                    </Tooltip>
                </ToggleButton>
            </ToggleButtonGroup>
        </>
    );
};

export default VehicleTypeToggle;
